import { z } from 'zod';
import { InitiativeSchema } from './entities.js';

// AI response schemas

export const SearchResultItemSchema = z.object({
  id: z.string().optional(),
  relevanceScore: z.number().min(0).max(1),
  matchReason: z.string().optional(),
  initiative: z.any().optional()
});

export const InitiativeSearchResponseSchema = z.object({
  relevantInitiatives: z.array(SearchResultItemSchema).default([]),
  insights: z.array(z.string()).default([]),
  suggestions: z.array(z.string()).default([]),
  summary: z.string().optional()
});

export const RiskItemSchema = z.object({
  category: z.string().optional().default('general'),
  description: z.string(),
  mitigation: z.string().optional().default(''),
  severity: z.enum(['low', 'medium', 'high']).optional().default('medium'),
  impact: z.string().optional().default('')
});

export const RiskAnalysisResponseSchema = z.object({
  risks: z.array(RiskItemSchema).default([]),
  summary: z.string().optional().default('')
});

// Portfolio analysis is narrative text; we normalize to an envelope
export const PortfolioNarrativeSchema = z.object({
  narrative: z.string().min(1)
});

export const TransferableInitiativeSchema = z.object({
  hasInitiative: z.boolean(),
  confidence: z.number().min(0).max(1).optional().default(0.5),
  initiative: InitiativeSchema.partial()
});

export const AiSchemas = {
  initiativeSearch: InitiativeSearchResponseSchema,
  riskAnalysis: RiskAnalysisResponseSchema,
  portfolioAnalysis: PortfolioNarrativeSchema,
  initiativeTransfer: TransferableInitiativeSchema,
  // New: InitiativeExtractor response used in DefineInitiative flow
  initiativeExtractor: z.object({
    objectives: z.array(z.object({ id: z.string().optional(), title: z.string(), description: z.string().optional().default('') })).default([]),
    key_results: z.array(z.object({ id: z.string().optional(), title: z.string(), metric: z.string().optional().default(''), target: z.string().optional().default('') })).default([]),
    stakeholders: z.array(z.object({ id: z.string().optional(), name: z.string(), type: z.string().optional().default('user'), segment: z.string().optional().default('') })).default([]),
    impacts: z.array(z.object({ id: z.string().optional(), title: z.string(), description: z.string().optional().default('') })).default([]),
    deliverables: z.array(z.object({ id: z.string().optional(), title: z.string() })).default([]),
    links: z.array(z.object({ from: z.string(), to: z.string(), type: z.string(), confidence: z.number().min(0).max(1).optional().default(0.5), reason: z.string().optional().default('') })).default([])
  })
};
